import type { ViewFieldsFragment } from '@salescore/client-api'
import { Form } from 'antd'
import { type ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { shouldPrivate, useViewDirectories } from '../../../../viewTree'
import { ViewGroupPicker } from '../../../form/ViewGroupPicker'

export const KpiFormViewGroupIdFormItem = ({
  view,
  viewGroupId,
  onChangeViewGroupId,
}: {
  view: ViewFieldsFragment
  viewGroupId: string | null | undefined
  onChangeViewGroupId: (viewGroupId: string | null) => void
}): ReactElement => {
  const { t } = useTranslation()
  const viewGroups = useViewDirectories()
  const isPrivate = useMemo(() => shouldPrivate(view, viewGroups), [view, viewGroups])

  return (
    <Form.Item data-e2e="kpi-form-name-form-item-folder-name" label={t(`フォルダ`)}>
      <ViewGroupPicker
        type={view.type}
        isPrivate={isPrivate}
        archived={false}
        value={viewGroupId}
        onChange={(value) => {
          if (typeof value !== 'string' && value !== null) {
            return
          }
          onChangeViewGroupId(value)
        }}
      />
    </Form.Item>
  )
}
